module.exports = "<mat-toolbar color=\"primary\">\n  <button style=\"font-size: 24px;\" mat-button>\n    Wiki\n  </button>\n</mat-toolbar>\n"